<template>
  <div>
    <GlobalSearch></GlobalSearch>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const GlobalSearch = defineAsyncComponent(() =>
  import("@/components/globalSearch/GlobalSearch")
);
export default {
  components: {
    GlobalSearch,
  },
};
</script>
